export class JsonUtils {

  /**
   * Tries to parse a string as JSON and returns the parsed object if valid.
   *
   * This method attempts to parse the given string as JSON. If the string is valid JSON,
   * it returns the parsed object. If the string is not valid JSON, it returns `null`.
   *
   * @param value - The string to be parsed as JSON.
   * @param elseValue - The string to be return if invalid JSON (default null).
   * @returns any elseValue - Returns the parsed JSON object if valid, or `elseValue` if the string is not valid JSON.
   */
  // tslint:disable-next-line:no-unnecessary-initializer
  public static parseJsonIfValid(value: string, elseValue: any = undefined): any {
    try {
      return JSON.parse(value);
    } catch (e) {
      return elseValue;
    }
  }
}

